import { Injectable, OnDestroy } from '@angular/core';
import { MessengerService } from '../messenger/messenger.service';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { IntervalService } from '../interval/interval.service';

@Injectable({
  providedIn: 'root'
})
export class MetaService implements OnDestroy {
  subscription: any;
  $changed = new BehaviorSubject<any>(false);
  meta: any;
  $backgroundImage = new BehaviorSubject<string>(null);
  $background = new BehaviorSubject<any>(null);

  constructor(private messenger: MessengerService, private localStorage: LocalStorageService) {
    this.subscription = this.messenger.$metaPackage.subscribe(packageMeta => {
      this.meta = packageMeta;
      this.$changed.next(this.meta);
      this.initBackground();
    });
  }

  private async initBackground() {
    if (this.meta?.images?.backgrounds?.multipleNew?.length) {
      this.$background.next(this.meta.images.backgrounds.multipleNew[0]);
      IntervalService.set('backgroundIntervalNew', () => {
        let bg = this.$background.getValue();
        const index = this.meta.images.backgrounds.multipleNew.findIndex(i => i === bg);
        this.$background.next(this.meta.images.backgrounds.multipleNew[index + 1] || this.meta.images.backgrounds.multipleNew[0]);
      }, this.getNumber('ibexTouch.backgroundChangeInterval', 1000 * 60 * 60));
    }
    if (this.meta?.images?.backgrounds?.multiple?.length) {
      this.$backgroundImage.next('url(' + this.meta.images.backgrounds.multiple[0] + ')');
      IntervalService.set('backgroundImageInterval', () => {
        let bg = this.$backgroundImage.getValue();
        bg = bg.split('(')[1].split(')')[0];
        const index = this.meta.images.backgrounds.multiple.findIndex(i => i === bg);
        this.$backgroundImage.next('url(' + (this.meta.images.backgrounds.multiple[index + 1] || this.meta.images.backgrounds.multiple[0]) + ')');
      }, this.getNumber('ibexTouch.backgroundChangeInterval', 1000 * 60 * 60));
    } else {
      this.$backgroundImage.next(await this.getBackgroundImage('clear'));
    }
  }

  public get(field: string): any {
    return _.get(this.meta, field);
  }

  public getBoolean(field: string): boolean {
    const value = this.get(field);
    if (value === false || value === true) {
      return value;
    } else {
      return _.isString(value) ? this.get(field) === 'true' : false;
    }
  }

  public getString(field: string, defaultValue?): string {
    return (!this.get(field) && defaultValue) ? defaultValue : (!!this.get(field) ? this.get(field).toString() : '');
  }

  public getNumber(field: string, defaultValue?): number {
    const res = this.get(field);
    if (!res && _.isNumber(defaultValue)) {
      return defaultValue
    } else if (res === 0 || !!res) {
      try {
        return parseInt(res);
      } catch (err) {
        return 0;
      }
    } else {
      return 0;
    }
  }

  public getBackgroundImage(field: string, defaultValue?): Promise<string> {
    field = 'images.backgrounds.' + field;
    const path = this.get(field);
    return !path ? Promise.resolve(defaultValue) : this.localStorage.getImage(path, false, true).then(url => {
      return 'url(' + url + ')';
    });
  }

  public getLocation(): { lat: any, lng: any } {
    if (this.get('location.lat') && (this.get('location.lng') || this.get('location.long'))) {
      return { lat: this.get('location.lat'), lng: this.get('location.lng') || this.get('location.long') };
    } else {
      return null;
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
